<template>
  <div style="margin: 30px 10px 0px 10px">
    <!-- 查询条件 -->
    <div style="width: 100%">
      <el-form
        ref="userManagementFormRef"
        :model="userManagementForm"
        label-width="auto"
      >
        <el-row :gutter="20">
          <el-col :span="7"
            ><div class="grid-content ep-bg-purple">
              <el-form-item label="用户ID">
                <el-input v-model="userManagementForm.id" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="7"
            ><div class="grid-content ep-bg-purple">
              <el-form-item label="用户名">
                <el-input v-model="userManagementForm.name" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="7"
            ><div class="grid-content ep-bg-purple">
              <el-form-item label="用户类型">
                <el-select
                  v-model="userManagementForm.type"
                  clearable
                  placeholder="请选择用户类型"
                >
                  <el-option label="超级管理员" value="superadmin" />
                  <el-option label="管理员" value="admin" />
                  <el-option label="普通用户" value="user" />
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="3"
            ><div class="grid-content ep-bg-purple">
              <el-button type="primary" @click="getUserList"
                ><el-icon><Search /></el-icon>查询</el-button
              >
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7"
            ><div class="grid-content ep-bg-purple">
              <el-form-item label="所属单位">
                <el-input v-model="userManagementForm.unit" />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="7"
            ><div class="grid-content ep-bg-purple">
              <el-form-item label="创建时间">
                <el-col :span="11">
                  <el-date-picker
                    v-model="userManagementForm.date1"
                    type="date"
                    placeholder="开始时间"
                    style="width: 100%"
                  />
                </el-col>
                <el-col :span="2" class="text-center">
                  <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="userManagementForm.date2"
                    placeholder="结束时间"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="7"
            ><div class="grid-content ep-bg-purple">
              <el-form-item label="注册通过状态">
                <el-select
                  v-model="userManagementForm.status"
                  clearable
                  placeholder="请选择注册通过状态"
                >
                  <el-option label="通过" value="true" />
                  <el-option label="不通过" value="false" />
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="3"
            ><div class="grid-content ep-bg-purple">
              <el-button type="info" @click="reset"
                ><el-icon><RefreshLeft /></el-icon>重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-divider />
    <!-- 用户数据表格 -->
    <el-table v-loading="loading" :data="filteredTableData" style="width: 100%">
      <el-table-column prop="name" label="用户名称" min-width="200" />
      <el-table-column prop="role" label="用户类型" min-width="160">
        <template #default="{ row }">
          {{ UserTypeMap[row.role] }}
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="用户电话" min-width="180" />
      <el-table-column prop="company" label="所属单位" min-width="180" />
      <el-table-column prop="is_auth" label="注册通过状态" width="140">
        <template #default="{ row }">
          {{ row.is_auth ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template #default="{ row }">
          <el-button type="primary" size="small" @click="handleAuth(row)">
            权限设置
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="绑定设备" width="260">
        <template #default="{ row, $index }">
          <el-select
            v-model="row.device_mac"
            collapse-tags
            multiple
            filterable
            collapse-tags-tooltip
            placeholder="请选择绑定的设备"
            @change="(val) => macChange(val, row, $index)"
          >
            <el-option
              v-for="item in macs"
              :key="item"
              :label="item"
              :value="item"
            />
            <template #footer>
              <el-button
                v-if="!isAdding"
                text
                size="small"
                @click="isAdding = true"
              >
                <span
                  style="font-size: 16px; display: flex; align-items: center"
                >
                  <span style="margin-right: 6px; font-size: 22px">+</span
                  ><span>新增MAC</span>
                </span>
              </el-button>
              <template v-else>
                <el-form ref="macFormRef" :model="macForm">
                  <el-form-item
                    :rules="[{ required: true, message: '请输入MAC ' }]"
                    label=""
                    label-width="0"
                    prop="newMac"
                  >
                    <el-input v-model="macForm.newMac" size="small" />
                  </el-form-item>
                </el-form>

                <el-button type="primary" size="small" @click="addMacSubmit">
                  确认
                </el-button>
                <el-button size="small" @click="cancelAdd">取消</el-button>
              </template>
            </template>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <!-- 权限设置对话框 -->
    <el-dialog v-model="dialogVisible" title="权限设置" width="30%">
      <el-form :model="authForm" label-width="80px">
        <el-form-item label="用户角色">
          <el-select v-model="authForm.role" placeholder="请选择用户角色">
            <el-option label="普通用户" value="user" />
            <el-option label="管理员" value="admin" />
            <el-option label="超级管理员" value="superadmin" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAuth">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, computed, set } from "vue";
import type { ElForm } from "element-plus";
import { UserTypeMap } from "../../enum";
import { getAllUsers, aduitUserRegister } from "../../api";
import { ElMessage } from "element-plus";
import { getMacApi, bindMacApi, addMacApi } from "@/api/index";
const userManagementForm = ref({
  id: "",
  name: "",
  type: "",
  unit: "",
  date1: "",
  date2: "",
  status: "",
});
const isAdding = ref(false);
const macForm = ref({
  newMac: "",
});
const macFormRef = ref(null);
const addMacSubmit = async () => {
  const valid = await macFormRef.value.validate().catch(() => false);
  if (!valid) return;
  const res = await addMacApi(macForm.value.newMac);
  if (res.code === "success") {
    ElMessage.success(res.message);
    getMacs();
    macForm.value.newMac = "";
    return;
  }
  ElMessage.error(res.message);
};
const cancelAdd = () => {
  isAdding.value = false;
  macForm.value.newMac = "";
};
interface IUserInfoData {
  name: string;
  role: string;
  phone: number;
  company: string;
  is_auth: boolean;
}
const userTableData = ref<IUserInfoData[]>([]);
const loading = ref(false);

const dialogVisible = ref(false);
const authForm = ref({
  phone: "",
  role: "",
});

const filteredTableData = computed(() => {
  return userTableData.value.filter((item) => {
    const matchId =
      !userManagementForm.value.id ||
      item.phone.toString().includes(userManagementForm.value.id);
    const matchName =
      !userManagementForm.value.name ||
      item.name.includes(userManagementForm.value.name);
    const matchType =
      !userManagementForm.value.type ||
      item.role === userManagementForm.value.type;
    const matchUnit =
      !userManagementForm.value.unit ||
      item.company.includes(userManagementForm.value.unit);
    const matchStatus =
      !userManagementForm.value.status ||
      item.is_auth.toString() === userManagementForm.value.status;

    let matchDate = true;
    if (userManagementForm.value.date1 && userManagementForm.value.date2) {
      // 如果有日期数据，这里需要根据实际数据结构调整日期比较逻辑
      // 当前数据中没有日期字段，暂时忽略日期筛选
    }

    return (
      matchId && matchName && matchType && matchUnit && matchStatus && matchDate
    );
  });
});

const macs = ref([]);
const getMacs = async () => {
  const res = await getMacApi();
  if (res.code === "success") {
    macs.value = res.content
      ?.filter((item) => !!item.mac)
      ?.map((item) => item.mac);
  }
};

const macChange = async (val, row, index) => {
  const res = await bindMacApi(val, row.phone);
  if (res.code === "success") {
    ElMessage.success(res.message || "操作成功");
    getUserList();
  }
};

const handleAuth = (row: IUserInfoData) => {
  authForm.value.phone = row.phone.toString();
  authForm.value.role = row.role;
  dialogVisible.value = true;
};

const submitAuth = async () => {
  try {
    const res = await aduitUserRegister({
      phone: authForm.value.phone,
      role: authForm.value.role as "user" | "admin" | "superadmin",
    });
    if (res.code === "success") {
      ElMessage.success(res.message || "操作成功");
      dialogVisible.value = false;
      getUserList();
    } else {
      ElMessage.error(res.message || "操作失败");
    }
  } catch (error) {
    ElMessage.error("操作失败");
  }
};

const getUserList = async () => {
  loading.value = true;
  const res = await getAllUsers();
  if (res?.code === "success") {
    userTableData.value = res.content as IUserInfoData[];
  }
  loading.value = false;
};

onMounted(() => {
  getUserList();
  getMacs();
});

const userManagementFormRef = ref<typeof ElForm>();
// 方法
const reset = () => {
  userManagementForm.value = {
    id: "",
    name: "",
    type: "",
    unit: "",
    date1: "",
    date2: "",
    status: "",
  };
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.icon-red {
  color: red;
}

.icon-green {
  color: green;
}

.icon-purple {
  color: purple;
}
</style>
